import { useContext, useEffect } from 'react';

import { css } from '@compiled/react';
import { UniformSlot } from '@uniformdev/canvas-react';
import { FilterableCardItemDataContext } from 'src/uniform/contexts/filterable-card-item-data-context';
import {
	FilterableItemIndexContext,
	useFilterableItemRegistry,
} from 'src/uniform/contexts/filterable-item-registry-context';

export interface FilterableItemProps {
	data?: unknown;
	fullHeight?: boolean | { value?: boolean };
}

const FilterableItem = ({ data, fullHeight = false }: FilterableItemProps) => {
	const registry = useFilterableItemRegistry();
	const index = useContext(FilterableItemIndexContext);
	const isFullHeight = resolveBooleanParameter(fullHeight, false);

	useEffect(() => {
		if (!registry) return;
		registry.registerItem(index, data);
		return () => registry.unregisterItem(index);
	}, [registry, index, data]);

	return (
		<FilterableCardItemDataContext.Provider value={data}>
			<div css={isFullHeight && fullHeightStyle}>
				<UniformSlot name="content" />
			</div>
		</FilterableCardItemDataContext.Provider>
	);
};

const resolveBooleanParameter = (
	parameter: boolean | { value?: boolean } | undefined,
	defaultValue: boolean,
) => {
	if (typeof parameter === 'boolean') return parameter;
	if (typeof parameter?.value === 'boolean') return parameter.value;
	return defaultValue;
};

const fullHeightStyle = css({
	height: '100%',
	display: 'grid',
});

export default FilterableItem;
